export const SUBSCRIBED_ARTS_LIMIT_STEPS = {
  READY: 'ready',
  UPGRADE_BONUS: 'upgrade_bonus',
  RECHARGE: 'recharge',
  EXIT: 'exit',
  SUCCESS_UPGRADE: 'success_upgrade',
  SUCCESS_UPGRADE_BONUS: 'success_upgrade_bonus',
  SUCCESS_RECHARGE: 'success_recharge',
}

export const PRO_UPGRADE = {
  name: 'Pro',
  artsPerMonth: 70,
  price: 'R$ 149,90/mês',
  unitPrice: 'R$ 2,14 por arte',
  description: 'Para quem cria com frequência. Cancele quando quiser.',
}

export const RECHARGE_PACKAGE = {
  artsCount: 25,
  price: 'R$ 119',
}

export const SUBSCRIBED_UPGRADE_BONUS_OFFER_CODE = 'subscribed_upgrade_bonus'

export const UPGRADE_BONUS_OFFER = {
  label: 'Pro · 70 artes + 20 de bônus no 1º mês',
  price: 'R$ 149,90/mês',
  subdescription: 'Oferta válida por 24h',
}

export const RECHARGE_DOWNSELL_OFFER = {
  label: 'Recarga avulsa',
  description: '25 artes',
  price: 'R$ 119',
  subdescription: 'Seu plano continua igual',
}

export const PLANS_OTHER_OPTIONS = [
  { id: 'business', tier: 4, label: 'Business · 140 artes/mês', price: 'R$ 299,90 /mês' },
]

export const RECHARGE_PACKAGE_OPTIONS = [
  { id: '10', label: '10 artes', price: 'R$ 49' },
  { id: '50', label: '50 artes', price: 'R$ 249' },
  { id: '100', label: '100 artes', price: 'R$ 499' },
]
